import _ from "lodash";
import FilterManager from "../app/helpers/filter-manager";
import LogiCommon from "../app/data-framework/logi-common";
import PermissionService from "./permission.service";
import LoginService from "./login.service";

function getTargetFromCategory(result, category) {
  // var appBaseUrl = _.includes(window.location.href, '#rooms') ? '#rooms' : '#historical2';
  let target = {
    call: '#historical2/endpoints/tabid/3',
    capacity: '',
    endpoint: '#historical2/endpoints/tabid/0',
    meeting: '#historical2/meetings/tabid/0',
    participant: '#historical2/meetings/tabid/2',
    schedulemeeting: '#rooms/bookings/tabid/0',
    scheduleroom: '#rooms/data/tabid/0',
    system: '#historical2/infrastructure/tabid/0',
    user: '#historical2/user/tabid/0',
  }[category];
  if (target) {
    result.target = target;
  }
  return result;
}

// Look at the metric and determine which page to go to
function getLhsForClickCallbackUrl(metricColumn, groupColumn) {
  var result = _.set({}, 'lhs', metricColumn.replace(/^.*\./, ''));

  if (_.includes(metricColumn, 'fctcall.')) {
    result.target = '#historical2/endpoints/tabid/3';

  } else if (_.includes(metricColumn, 'fctmanageendpoint')) {
    result.target = '#historical2/endpoints/tabid/0';

  } else if (_.includes(metricColumn, 'fctunmanageendpoint')) {
    result.target = '#historical2/endpoints/tabid/1';

  } else if (metricColumn === 'fctmeetingpeak_day.meetingcurrentsystem') {
    if (groupColumn === 'dimsystem.systemtype') {
      result.target = '#historical2/sysconcurrentmeetingpeakbysystypecapacitydetails';

    } else if (groupColumn === 'dimsystem.systemname') {
      result.target = '#historical2/sysconcurrentmeetingpeakbysysnamecapacitydetails';
    }

    result.readOnly = true;

  } else if (metricColumn === 'fctmeetingpeak_system_day.meetingcurrentsystem' && groupColumn === 'dimsystemtype.systemtype') {
    result.target = '#historical2/systypeconcurrentmeetingpeakcapacitydetails';
    result.readOnly = true;

  } else if (_.includes(metricColumn, 'fctmeeting')) {
    result.target = '#historical2/meetings/tabid/0';

  } else if (_.includes(metricColumn, 'fctparticipant')) {
    result.target = '#historical2/meetings/tabid/2';

  } else if (_.includes(metricColumn, 'fctscheduleroom')) {
    result.target = '#rooms/data/tabid/0';

  } else if (_.includes(metricColumn, 'fctsystem')) {
    result.target = '#historical2/infrastructure/tabid/0';

  } else if (_.includes(metricColumn, 'dimtrunk')) {
    result.target = '#historical2/infrastructure/tabid/1';

  } else if ((_.includes(metricColumn, 'fctcapacity.')) && (groupColumn === 'dimsystem.systemname')) {
    result.target = '#historical2/capacitydetails';
    result.readOnly = true;

  } else if ((_.includes(metricColumn, 'fctclustercapacity.')) && (groupColumn === 'dimcluster.clustername')) {
    result.target = '#historical2/clustercapacitydetails';
    result.readOnly = true;

  } else if (_.includes(metricColumn, 'fcttrunkcapacity.') && (groupColumn === 'dimtrunk.name')) {
    result.target = '#historical2/trunkcapacitydetails';
    result.readOnly = true;

  } else if (_.includes(metricColumn, 'fctcallpeak_day.callcurrentsystem') && (groupColumn === 'dimendpointlocation.location')) {
    result.target = '#historical2/concurrentcallscapacitydetails';
    result.readOnly = true;

  } else if (_.includes(metricColumn, 'fctcallpeak_day.callcurrentbandwidth') && (groupColumn === 'dimendpointlocation.location')) {
    result.target = '#historical2/concurrentbandwidthcapacitydetails';
    result.readOnly = true;

  } else {
    result.target = '';
  }

  if (!groupColumn || (groupColumn === '(no grouping)')) {
    result.groupFilter = '';

  } else {
    result.groupFilter = groupColumn;
    result.op = '=';
  }

  return result;
}

let AREA_TREND = 'Area Trend';
let STACKED_AREA_TREND = 'Stacked Area Trend';
let BAR = 'Bar';
let BAR_TREND = 'Bar Trend';
let LINE_TREND = 'Line Trend';
let PIE = 'Pie';
let TABLE = 'Table';
let TREND = 'Trend';
let KPI = 'KPI';

class ClickThruService {

  constructor () {
    if(ClickThruService.instance) {
      return ClickThruService.instance;
    }

    this.logiCommon = new LogiCommon();
    ClickThruService.instance = this;
  }

  clickThru(type, metricColumn, groupColumn, category, whereConditionObj, date, start, end, filterval, notin, groupColumns) {

    // ideally we'd do this earlier in the stack
    var permissionService = new PermissionService(LoginService.userObject);
    if (!permissionService.hasPermission(permissionService.ViewDatasetsPermission)) {
      return;
    }
    
    // Figure out which page to go to
    var result = getLhsForClickCallbackUrl(metricColumn, groupColumn);
    if (!result.target) {
      result = getTargetFromCategory(result, category);
    }

    if (type === TREND) {
      result.readOnly = true;
    }

    if (!result.target ||
        (type === PIE && category === 'capacity')) {
      return;
    }

    var newtab;

    if (_.includes(result.target, 'capacitydetails')) {
      newtab = true;
      end = start;
    } else {
      newtab = false;
    }

    var paramsURI = '';

    var filters = whereConditionObj || [];
    let newFilters = [];

    let groupFilter = {};
    if (notin) {
      groupFilter = {
        selectedLhs: result.groupFilter,
        selectedOperator: 'notin',
        rhsText: filterval
      };
    } else if (result.groupFilter) {
      groupFilter = {
        selectedLhs: result.groupFilter,
        selectedOperator: '=',
        rhsText: filterval
      };
    }

    let valueType = 'string';

    if (result.groupFilter && groupColumns) {
      let groupColumn = _.find(groupColumns, { columnKey: result.groupFilter });
      groupFilter.selectedLhsTitle = _.get(groupColumn, 'columnDescription');
      groupFilter.valueType = _.get(groupColumn, 'columnType', 'string');

    }

    if (groupFilter.selectedLhs) {
      if (groupFilter.selectedLhs.toLowerCase().indexOf('dnsystemsid') >= 0) {
        groupFilter.valueType = 'integer';
      }
      newFilters.push(groupFilter);
    }

    let smartFilters = {
      'fctschedulemeeting.attendedmeetingminute': { selectedLhs: 'fctschedulemeeting.attendedmeetingminute', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctschedulemeeting.missedmeetingminute': { selectedLhs: 'fctschedulemeeting.missedmeetingminute', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctschedulemeeting.schedulemeetingminute': { selectedLhs: 'fctschedulemeeting.schedulemeetingminute', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctschedulemeeting.unusedmeetingminute': { selectedLhs: 'fctschedulemeeting.unusedmeetingminute', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },

      'fctcall.callcountaudio': { selectedLhs: 'dimmodality.modality = Audio', valueType:'string', selectedConjunction: 'AND' },
      'fctcall.callcountvideo': { selectedLhs: 'dimmodality.modality = Video', valueType:'string', selectedConjunction: 'AND' },
      'fctcall.callhour': { selectedLhs: 'fctcall.callminute', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctcall.callhouraudio': { selectedLhs: 'fctcall.callminuteaudio', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctcall.callhourvideo': { selectedLhs: 'fctcall.callminutevideo', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctcall.callminute': { selectedLhs: 'fctcall.callminute', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctcall.callminuteaudio': { selectedLhs: 'fctcall.callminuteaudio', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctcall.callminutevideo': { selectedLhs: 'fctcall.callminutevideo', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },

      'fctmanageendpoint.callcountaudio': { selectedLhs: 'fctmanageendpoint.callcountaudio', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctmanageendpoint.callhouraudio': { selectedLhs: 'fctmanageendpoint.callminuteaudio', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctmanageendpoint.callminuteaudio': { selectedLhs: 'fctmanageendpoint.callminuteaudio', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctendpointstatus.endpointminuteup': { selectedLhs: 'fctendpointstatus.endpointminuteup', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctendpointstatus.endpointminutedown': { selectedLhs: 'fctendpointstatus.endpointminutedown', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctmanageendpoint.callcount': { selectedLhs: 'fctmanageendpoint.callcount', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctmanageendpoint.callhour': { selectedLhs: 'fctmanageendpoint.callminute', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctmanageendpoint.callminute': { selectedLhs: 'fctmanageendpoint.callminute', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctmanageendpoint.callcountvideo': { selectedLhs: 'fctmanageendpoint.callcountvideo', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctmanageendpoint.callhourvideo': { selectedLhs: 'fctmanageendpoint.callminutevideo', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctmanageendpoint.callminutevideo': { selectedLhs: 'fctmanageendpoint.callminutevideo', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },

      'fctmeeting.meetingparticipantcountaudio': { selectedLhs: 'fctmeeting.meetingparticipantcountaudio', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctmeeting.meetingminute': { selectedLhs: 'fctmeeting.meetingminute', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctmeeting.meetingparticipantminuteaudio': { selectedLhs: 'fctmeeting.meetingparticipantminuteaudio', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctmeeting.meetingparticipantminute': { selectedLhs: 'fctmeeting.meetingparticipantminute', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctmeeting.meetingparticipantminutevideo': { selectedLhs: 'fctmeeting.meetingparticipantminutevideo', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },

      'fctwebexpstncategory.meetingminute': { selectedLhs: 'fctwebexpstncategory.meetingminute', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctmeeting.meetingparticipantcountvideo': { selectedLhs: 'fctmeeting.meetingparticipantcountvideo', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },


      'fctparticipant.participantcountaudio': { selectedLhs:'dimmodality.modality', selectedOperator: '=', rhsText: 'Audio', valueType:'string', selectedConjunction: 'AND' },
      'fctparticipant.meetingparticipantcountaudio': { selectedLhs:'fctparticipant.participantcountaudio', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctparticipant.meetingminute': { selectedLhs:'fctparticipant.meetingminute', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctparticipant.participantminuteaudio': { selectedLhs:'fctparticipant.participantminuteaudio', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctparticipant.participantminute': { selectedLhs:'fctparticipant.participantminute', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctparticipant.participantminutevideo': { selectedLhs:'fctparticipant.participantminutevideo', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctparticipant.meetingparticipantminuteaudio': { selectedLhs:'fctparticipant.meetingparticipantminuteaudio', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctparticipant.meetingparticipantminute': { selectedLhs:'fctparticipant.meetingparticipantminute', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctparticipant.meetingparticipantminutevideo': { selectedLhs:'fctparticipant.meetingparticipantminutevideo', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctparticipant.participantcountvideo': { selectedLhs:'dimmodality.modality', selectedOperator: '=', rhsText: 'Video', valueType:'string', selectedConjunction: 'AND' },

      'fctscheduleroom.meetingcountattended': { selectedLhs:'fctscheduleroom.meetingcountattended', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctscheduleroom.usedminute': { selectedLhs:'fctscheduleroom.usedminute', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctscheduleroom.audiocallcount': { selectedLhs:'fctscheduleroom.audiocallcount', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctscheduleroom.audiocallminute': { selectedLhs:'fctscheduleroom.audiocallminute', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctscheduleroom.incallpresentingminute': { selectedLhs:'fctscheduleroom.incallpresentingminute', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctscheduleroom.meetingcountmissed': { selectedLhs:'fctscheduleroom.meetingcountmissed', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctscheduleroom.missedmeetingminute': { selectedLhs:'fctscheduleroom.missedmeetingminute', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctscheduleroom.emptyroomminute': { selectedLhs:'fctscheduleroom.emptyroomminute', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctscheduleroom.noncallpresentingminute': { selectedLhs:'fctscheduleroom.noncallpresentingminute', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctscheduleroom.occupancyroomminute': { selectedLhs:'fctscheduleroom.occupancyroomminute', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'scheduleroomxml.peopleonlycount': { selectedLhs:'scheduleroomxml.peopleonlycount', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'scheduleroomxml.peopleonlymin': { selectedLhs:'scheduleroomxml.peopleonlymin', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctscheduleroom.presentationcount': { selectedLhs:'fctscheduleroom.presentationcount', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctscheduleroom.presentationminute': { selectedLhs:'fctscheduleroom.presentationminute', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctscheduleroom.meetingcount': { selectedLhs:'fctscheduleroom.meetingcount', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctscheduleroom.schedulemeetingminute': { selectedLhs:'fctscheduleroom.schedulemeetingminute', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctscheduleroom.totalcallminute': { selectedLhs:'fctscheduleroom.totalcallminute', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctscheduleroom.unusedminute': { selectedLhs:'fctscheduleroom.unusedminute', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctscheduleroom.videocallcount': { selectedLhs:'fctscheduleroom.videocallcount', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctscheduleroom.videocallminute': { selectedLhs:'fctscheduleroom.videocallminute', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },

      'fctsystem.callcountaudio': { selectedLhs:'fctsystem.callcountaudio', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctsystem.callminuteaudio': { selectedLhs:'fctsystem.callminuteaudio', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctsystemstatus.systemminuteup': { selectedLhs:'fctsystemstatus.systemminuteup', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctsystemstatus.systemminutedown': { selectedLhs:'fctsystemstatus.systemminutedown', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctsystem.callcount': { selectedLhs:'fctsystem.callcount', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctsystem.callminute': { selectedLhs:'fctsystem.callminute', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctsystem.callcountvideo': { selectedLhs:'fctsystem.callcountvideo', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctsystem.callminutevideo': { selectedLhs:'fctsystem.callminutevideo', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },

      'fctuser.meetingminute': { selectedLhs:'fctuser.meetingminute', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctuser.meetingcount': { selectedLhs:'fctuser.meetingcount', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctuser.meetingparticipantminute': { selectedLhs:'fctuser.meetingparticipantminute', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctuser.schedulemeetingattended': { selectedLhs:'fctuser.schedulemeetingattended', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctuser.schedulemeetingmissed': { selectedLhs:'fctuser.schedulemeetingmissed', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctuser.schedulemeetingcount': { selectedLhs:'fctuser.schedulemeetingcount', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctuser.webexmeetingminute': { selectedLhs:'fctuser.webexmeetingminute', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctuser.webexmeetingcount': { selectedLhs:'fctuser.webexmeetingcount', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
      'fctuser.webexmeetingparticipantminute': { selectedLhs:'fctuser.webexmeetingparticipantminute', selectedOperator: '>', rhsText: '0', valueType:'numeric', selectedConjunction: 'AND' },
    };

    if (smartFilters[metricColumn]) {
      let smartFilter = smartFilters[metricColumn];
      let smartColumn = _.find(groupColumns, { columnKey: smartFilter.selectedLhs });
      let smartLhstitle = _.get(smartColumn, 'columnDescription');
      smartFilter.selectedLhsTitle = smartLhstitle;

      newFilters.push(smartFilter);
    }


    if (!_.isEmpty(newFilters)) {
      filters.push({
        selectedConjunction:  'AND',
        conditions: newFilters
      });
    }

    if (!_.isEmpty(filters)) {
      let condition = {
        WhereConditionObj: filters,
        WhereConditionConjunction: 'AND',
        inpStartDate: start,
        inpEndDate: end
      };
      FilterManager.setCurrentFilters(JSON.stringify(condition));
      paramsURI = paramsURI + '/params/hasFilters|true';
    }

    var url = result.target + paramsURI;

    if (!!result.readOnly) {
      // signal that Save Preferences should be disabled
      url += '?nosave=true';
    }

    if (newtab) {
      window.open(url, '_blank');

    } else {
      window.location.href = url;
    }

  }

}


const instance = new ClickThruService();
Object.freeze(instance);

export default instance;
